module.exports = __webpack_public_path__ + "assets/img/b8931fd57dc5e268f3157bd8ec0769db.svg";